enum SecuritySchemes {
  APIKey = 'roblox-api-key',
  OAuth2 = 'roblox-oauth2',
  Cookie = 'roblox-cookie',
}

export default SecuritySchemes;
